import { Navigate, Route, Routes } from 'react-router-dom';
import { Navigation } from '@components/Navigation/Navigation';
import { ErrorBoundary } from '@components/ErrorBoundary/ErrorBoundary';
import LightroomConverter from '@pages/LightroomConverter/LightroomConverter';
import styles from './App.module.css';

function App() {
  return (
    <div className={styles.root}>
      <Navigation />
      <main className={styles.main} role="main">
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Navigate to="/lut" replace />} />
            <Route path="/lut" element={<LightroomConverter />} />
            <Route path="*" element={<Navigate to="/lut" replace />} />
          </Routes>
        </ErrorBoundary>
      </main>
    </div>
  );
}

export default App;
